import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { getJson } from 'session';
import * as actions from '../actions';

function ReprintTransmittalModal({ getReportAccess}) {
  const [formData, setFormData] = useState({
    transmittal_no: '',
  });
  // const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const setModal = useContext(ModalContext);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // eslint-disable-next-line consistent-return
  const handleOnSubmit = e => {
    e.preventDefault();

    const query = {
      email: _.get(authProfile, 'email'),
      transmittal_no: _.get(formData, 'transmittal_no'),
      output: 'D',
    };

    const args = {
      path: `api/v1/bpls/administrator/transaction_histories/transmittal/view`,
      query,
    };

    getReportAccess(args, (data) => {
      const src = `${data?.res?.res?.url || ''}`;
  
      setTimeout(() => {
        window.location.href = src;
        setFormData({
          ...formData,
          isLoading: false,
          generate: false,
        });
      }, 100);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Transmittal Number:
            </label>
            <input
              className="form-control"
              type="text"
              name="transmittal_no"
              onChange={onChange}
              value={_.get(formData, 'transmittal_no')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   ">
            <span className="font-weight-bold">Print</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ReprintTransmittalModal.propTypes = {
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ReprintTransmittalModal);
